<section class="main-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/admin/dashboard/">Home</a></li>
      <li class="breadcrumb-item"><a routerLink="/admin/storeIntegrations/">Channels</a></li>
      <li class="breadcrumb-item"><a routerLink="/admin/storeConnections/">Create Channel</a></li>
      <li class="breadcrumb-item active" aria-current="page">Amazon</li>
    </ol>
  </nav>

  <div class="row">
    <div class="col">
      <div class="inner-box p-4">
        <div class="row">
          <div class="col-md-3 offset-md-9 align-self-end">
            <div class="instr-box">
              <span>Amazon Market Place Instructions </span>
              <svg xmlns="http://www.w3.org/2000/svg" width="17.14" height="17.14" viewBox="0 0 17.14 17.14">
                <path id="Icon_awesome-question-circle" data-name="Icon awesome-question-circle"
                      d="M17.7,9.132A8.57,8.57,0,1,1,9.132.563,8.569,8.569,0,0,1,17.7,9.132ZM9.362,3.4A4.476,4.476,0,0,0,5.335,5.6a.415.415,0,0,0,.094.562l1.2.909A.415.415,0,0,0,7.2,7c.617-.783,1.041-1.237,1.98-1.237.706,0,1.579.454,1.579,1.139,0,.518-.427.783-1.124,1.174C8.826,8.529,7.75,9.1,7.75,10.515v.138a.415.415,0,0,0,.415.415H10.1a.415.415,0,0,0,.415-.415v-.046c0-.984,2.875-1.024,2.875-3.686C13.389,4.916,11.31,3.4,9.362,3.4Zm-.23,8.57a1.59,1.59,0,1,0,1.59,1.59A1.591,1.591,0,0,0,9.132,11.966Z"
                      transform="translate(-0.563 -0.563)" fill="#c1c1c1"/>
              </svg>
            </div>
            <!-- PROD URL-->
            <!--<a
              href="{{'https://sellercentral.amazon.in/ap/signin?clientContext=262-3208898-2959436&openid.return_to=https%3A%2F%2Fsellercentral.amazon.in%2Fapps%2Fauthorize%2Fconsent%3Fapplication_id%3Damzn1.sp.solution.a4e01814-70df-48a9-a3d3-3c6d4b3d3a98%26state%3D'+user.accountOwnerId +'%26version%3Dbeta&openid.identity=http%3A%2F%2Fspecs.openid.net%2Fauth%2F2.0%2Fidentifier_select&openid.assoc_handle=sc_in_amazon_v2&openid.mode=checkid_setup&openid.claimed_id=http%3A%2F%2Fspecs.openid.net%2Fauth%2F2.0%2Fidentifier_select&openid.ns=http%3A%2F%2Fspecs.openid.net%2Fauth%2F2.0&ssoResponse=eyJ6aXAiOiJERUYiLCJlbmMiOiJBMjU2R0NNIiwiYWxnIjoiQTI1NktXIn0.pZNiJhMOnleThDxjoM02We-eTmaq_SvBJ-bW9PzEn1NYWRJnYzfX9A.qOx8cZ9qsGIu9uUF.JoPS3FjjG3Q7BdWbDRZ7pyBzQPron3JMGBzbk2zQJWqaeniHIUudyPskussWzXBSDsMaztXsmAdjS4d6U8aq-NFToBZ0yhaocZuqUiPa0YrgU8fES_XCvQa9zt9bVYJynjK8f70L8m0DZK0K6aWOiiOp1S-l7AL8nEKI7cT6rgeuTNHPUffoj5vDbJE1dDAusClsRAx6J14HmFO3qLHdQCq4WqlcFhi9jXkz98JhQ-1bMNtWOr_UwYd8RaTfEKYUmiF8.YxDvnAwpRtcuHElO9KCBzQ'}}"
              target="_blank" class="btn btn-orange btn-block">Authorize & Save
            </a>-->
            <!-- DEV URL-->
            <a
              href="{{'https://sellercentral.amazon.in/ap/signin?clientContext=262-3208898-2959436&openid.return_to=https%3A%2F%2Fsellercentral.amazon.in%2Fapps%2Fauthorize%2Fconsent%3Fapplication_id%3Damzn1.sp.solution.4ebe3a60-c020-40e0-bfbd-6a0198891f60%26state%3D'+user.accountOwnerId +'%26version%3Dbeta&openid.identity=http%3A%2F%2Fspecs.openid.net%2Fauth%2F2.0%2Fidentifier_select&openid.assoc_handle=sc_in_amazon_v2&openid.mode=checkid_setup&openid.claimed_id=http%3A%2F%2Fspecs.openid.net%2Fauth%2F2.0%2Fidentifier_select&openid.ns=http%3A%2F%2Fspecs.openid.net%2Fauth%2F2.0&ssoResponse=eyJ6aXAiOiJERUYiLCJlbmMiOiJBMjU2R0NNIiwiYWxnIjoiQTI1NktXIn0.pZNiJhMOnleThDxjoM02We-eTmaq_SvBJ-bW9PzEn1NYWRJnYzfX9A.qOx8cZ9qsGIu9uUF.JoPS3FjjG3Q7BdWbDRZ7pyBzQPron3JMGBzbk2zQJWqaeniHIUudyPskussWzXBSDsMaztXsmAdjS4d6U8aq-NFToBZ0yhaocZuqUiPa0YrgU8fES_XCvQa9zt9bVYJynjK8f70L8m0DZK0K6aWOiiOp1S-l7AL8nEKI7cT6rgeuTNHPUffoj5vDbJE1dDAusClsRAx6J14HmFO3qLHdQCq4WqlcFhi9jXkz98JhQ-1bMNtWOr_UwYd8RaTfEKYUmiF8.YxDvnAwpRtcuHElO9KCBzQ'}}"
              target="_blank" class="btn btn-orange btn-block">Authorize & Save
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row mt-4" id="instructions">
    <div class="col">
      <div class="inner-box pb-0 pt-4 h-auto">
        <div class="row">
          <div class="col-12">
            <div class="row no-gutters">
              <label>
                <b>Amazon MWS Instructions :</b>
              </label>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <ul>
                <li>
                  Amazon MWS or Marketplace Web Service is typically an integrated web service API which allows the
                  sellers to carry out various tasks related to orders, payments, deliveries and more.
                </li>
                <li>
                  These include, booking slots, scheduling pickups, tracking pickups, generating labels, among others.
                </li>
                <li>
                  When a seller selects MWS, the orders placed are picked from the seller’s location or warehouse by
                  Amazon logistics and delivered straight to the customer anywhere.
                </li>
                <li>
                  Although the packaging and warehousing are taken care of by the seller, it eliminates shipping and
                  logistics woes largely, which proves to be quite convenient.
                </li>
                <li>
                  Leveraging the Amazon MWS can help increase efficiency, improve consumer response time and even reduce
                  labor costs.
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="row no-gutters">
              <label>
                <b>Amazon Selling Partner API Instructions :</b>
              </label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <ul>
              <li>
                Amazon Selling Partner API or SP-API is seen to be the next generation suite of API-based automation
                functionality for sellers of today.
              </li>
              <li>
                A step up from its MWS APIs, this includes several additional APIs, even for the vendors
              </li>
              <li>
                This allows the products of retailers to be entirely handled by Amazon.
              </li>
              <li>
                They are stored at Amazon fulfillment centers and are picked, packed and delivered to the end customers
                by Amazon, when the orders are placed.
              </li>
              <li>
                It comes with associated costs, but is low-maintenance comparatively.
              </li>
              <li>
                Moreover, the sellers who meet a certain criteria are allowed to cater to Amazon customers, when an
                order is placed, from their own warehouses.
              </li>
              <li>
                Here the seller is in complete control of the entire process and resources instead of paying a service
                fee to Amazon and delivers products directly to the customer.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
